<template>
  <div class="page-taobaoAuth">
    <Navigation title="淘宝账户授权登录" isListenClick @listenClick="handleClickBack" />
    <div class="content-wrap"></div>
  </div>
</template>

<script>
import Navigation from '@/components/navigation'
import Consts from '@/common/consts'
import Cookie from '@/utils/cookie'
import LocalStore from '@/utils/localStore'
import LoginService from '@/services/login'
import { Toast, Dialog } from 'mand-mobile'
export default {
  name: 'taobaoAuth',
  components: {
    Navigation,
    [Toast.component.name]: Toast,
    [Dialog.name]: Dialog,
  },
  data() {
    return {}
  },
  created() {
    this.initData()
  },
  methods: {
    /**
     * 初始化数据
     */
    initData() {
      console.log('携带参数', this.$route.query.params)
      console.log('window.history', window.history)
      if (this.$route.query.error) {
        this.showFail('授权失败, 请重试')
      } else if (this.$route.query.code) {
        Toast.loading('授权中...')
        const redirecUri = `${Consts.TB_AUTH_CALLBACK_HOST}/auth/taobao`
        const code = this.$route.query.code
        const state = this.$route.query.state
        console.log('获取code', `code=${code}, state=${state}`)
        this.$http
          .tbk.bindTb(redirecUri, code)
          .then(res => {
            // 刷新绑定状态
            LoginService.checkBindTb((isBind, data) => {}, 0)
            Toast.hide()
            Dialog.alert({
              title: '提示',
              content: '授权成功',
              confirmText: '确定',
              onConfirm: () => {
                this.handleClickBack()
              },
            })
          })
          .catch(err => {
            Toast.hide()
            this.showFail(err.message)
          })
      }
    },
    /**
     * 显示失败
     */
    showFail(msg) {
      let message = msg
      if (msg === '鉴权失败!') {
        message = '淘宝授权失败, 请返回后重新授权'
      } else if (msg === '该淘宝已经绑定其他董事惠账号!') {
        message = '该淘宝账户已绑定董事惠商城其他账号, 请返回后重新操作'
      }
      Dialog.failed({
        title: '',
        content: message,
        confirmText: '返回上一步',
        cancelText: '首页',
        onCancel: () => {
          this.$router.push({ name: 'home' })
        },
        onConfirm: () => {
          this.handleClickBack()
        },
      })
    },
    /**
     * 点击返回
     */
    handleClickBack() {
      const params = this.$route.query
      const len = window.history.length - parseInt(params.lastHistoryLength || window.history.length)
      console.log('页面参数', params)
      console.log('回退到', -len)
      if (len > 0) {
        window.history.go(-len)
      } else if (params.target) {
        const nextPath = decodeURIComponent(params.target)
        this.$router.replace({ path: nextPath })
      } else {
        this.$router.replace({ name: 'home' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.page-taobaoAuth {
  position: relative;
  overflow: hidden;
  height: 100%;
  .content-wrap {
    background: #ededed;
    padding: 0 0.3rem;
  }
}
</style>
